(() => {
  const config = document.querySelector('script[data-lucent-reviews]');
  if (!config) return;
  const update = () => {
    const widget = document.querySelector('#judgeme_product_reviews');
    const reviews = widget?.querySelector('.jdgm-rev-widg');
    if (!reviews) return;
    const count = Number(reviews.dataset.numberOfReviews);
    const rating = Number(reviews.dataset.averageRating);
    const summary = document.querySelector('.lucent-feedback-summary');
    if (count > 0 && rating > 0 && summary) {
      const label = (count === 1 ? config.dataset.ratingSingle : config.dataset.rating).replace('__rating__', rating.toFixed(2)).replace('__count__', count);
      if (summary.textContent !== label) summary.textContent = label;
    }
    const header = reviews.querySelector('.jdgm-rev-widg__header');
    if (count === 0 && header && !header.querySelector('.lucent-review-empty')) {
      const message = document.createElement('p');
      message.className = 'lucent-review-empty';
      message.textContent = config.dataset.empty;
      const link = document.createElement('a');
      link.className = 'lucent-review-store-link';
      link.href = config.dataset.storeUrl;
      link.textContent = config.dataset.storeLink;
      header.append(message, link);
    }
  };
  update();
  const widget = document.querySelector('#judgeme_product_reviews');
  if (widget) new MutationObserver(update).observe(widget, {childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
})();
